import { Typography } from 'antd'

const { Title, Paragraph } = Typography

const CGA = () => {
  return (
    <>
      <Title level={2}>Conditions Générales d&apos;Abonnement</Title>
      <Paragraph>Lorem ipsum dolor sit amet</Paragraph>
    </>
  )
}

export default CGA
